<div class="borderLight" style="display: flex; padding:0px 10px;">
  <ion-card style="width: 150px !important;" class="margin0 padding5">
    {{master.name}}
    <ion-icon name="ellipsis-vertical" (click)="masterAction()"></ion-icon>
    <ion-icon name="chevron-down" class="floatRight font2" *ngIf="master.showChild"
      (click)="master.showChild=false"></ion-icon>
    <ion-icon name="chevron-forward" class="floatRight font2" *ngIf="!master.showChild"
      (click)="getChildList()"></ion-icon>
  </ion-card>
  <div class="borderLight" *ngIf="master.showChild">
    <app-master-box *ngFor="let child of childMasterList" [master]="child"></app-master-box>
  </div>
</div>

<!-- <div >
  <app-box [update]="update" [box]="box"></app-box>
  <div *ngIf="box.child_list">
    <app-box-hierarchy *ngFor="let child of box.child_list" [box]="child" [update]="update"></app-box-hierarchy>
  </div>
</div> -->